export const preferences = {
  apiUrl: 'https://raw.githubusercontent.com/LyonDataViz/oddata-public/master/',
  attribute: 'countrycode',
  dataset: 'quickdraw/circle.json',
  mode: 'grid',
  rowsLimit: 1000,
}
